import api from './index';
import { getStartAndEndOfAMonth } from '../utils/dateUtils';
import dayjs, { Dayjs } from '@utils/dayjs';
import { DATE_FORMATS } from '@callmart/types';
import { getTotalsTypeByValue } from '../enums/TotalsType';
import { extractContentType, XLSX_CONTENT_TYPE } from '../utils/fetchUtils';
import { appTimezone } from '../config';

const BASE = '/totals';

export const getTotals = async ({
    dateFrom,
    dateTo,
    workingUnitLocation,
}: {
    dateFrom?: Dayjs;
    dateTo?: Dayjs;
    workingUnitLocation?: number;
} = {}) => {
    return api
        .get(BASE, {
            params: {
                dateFrom: dateFrom ? dateFrom.toISOString() : undefined,
                dateTo: dateTo ? dateTo.toISOString() : undefined,
                workingUnitLocation,
            },
        })
        .then((res) => res.data);
};

export const getTotalsWithWorkingUnits = async ({
    dateFrom,
    dateTo,
    location,
    totalsType,
}: {
    dateFrom?: Dayjs;
    dateTo?: Dayjs;
    location?: number;
    totalsType?: string;
} = {}) => {
    return api
        .get(`${BASE}/with-working-units`, {
            params: {
                dateFrom: dateFrom ? dateFrom.toISOString() : undefined,
                dateTo: dateTo ? dateTo.toISOString() : undefined,
                location,
                totalsType,
            },
        })
        .then((res) => res.data);
};

export const getTotalsExportData = async ({
    dateFrom,
    dateTo,
    totalsType,
}: {
    dateFrom?: Dayjs;
    dateTo?: Dayjs;
    totalsType?: string;
}) => {
    return api
        .get(`${BASE}/export`, {
            params: {
                dateFrom: dateFrom ? dateFrom.toISOString() : undefined,
                dateTo: dateTo ? dateTo.toISOString() : undefined,
                totalsType,
            },
        })
        .then((res) => res.data);
};

export const exportTotalsData = async ({
    date,
    totalsType,
}: {
    date: Date | Dayjs | string;
    totalsType: 'bidding' | 'corrected';
}) => {
    const { dateFrom, dateTo } = getStartAndEndOfAMonth(date);
    const response = await api.get<Blob>(`${BASE}/export-file`, {
        params: {
            dateFrom: dateFrom.toISOString(),
            dateTo: dateTo.toISOString(),
            totalsType,
        },
        responseType: 'blob',
    });

    const nameTef = getTotalsTypeByValue(totalsType).nameTEF;
    const month = dayjs(date).tz(appTimezone).format(DATE_FORMATS.MONTH_YEAR);

    return {
        data: response.data,
        contentType: extractContentType(response.headers) || XLSX_CONTENT_TYPE,
        fileName: `${nameTef}_${month}.xlsx`,
    };
};
